module.exports = __webpack_public_path__ + "img/20191101105011微信截图_20191101105056.6aac0a66.png";